import { Trans, useTranslation } from "react-i18next";
import { HiMagnifyingGlass } from "react-icons/hi2";

import FeaturedText from "@/components/molecules/FeaturedText";

const NoListResults = ({ query }: { query: string }) => {
  const { t } = useTranslation();

  return (
    <FeaturedText
      featuredIcon={{ icon: HiMagnifyingGlass }}
      heading={t("static.noResults.title")}
      body={<Trans i18nKey="static.noResults.text" values={{ query }} components={{ bold: <strong /> }} />}
    />
  );
};

export default NoListResults;
